import { render, staticRenderFns } from "./trade_mgt.vue?vue&type=template&id=4dc902af&scoped=true"
import script from "./trade_mgt.vue?vue&type=script&lang=js"
export * from "./trade_mgt.vue?vue&type=script&lang=js"
import style0 from "./trade_mgt.vue?vue&type=style&index=0&id=4dc902af&prod&lang=less"
import style1 from "./trade_mgt.vue?vue&type=style&index=1&id=4dc902af&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc902af",
  null
  
)

export default component.exports